<template>
  <div v-if="isSupport" class="menu">
    <li
      class="list-group-item"
      v-on:click="isMenuOpened = !isMenuOpened"
    >
      <img class="menu-logo" :src="app_root + '/assets/common/img/printlink/LINE_APP.png'" alt="LINE_APP" align="middle">
      <LabelFunMessage fcontId="0" msgkey="125" />
      <span
        v-if="!isMenuOpened"
        class="glyphicon glyphicon-chevron-down"
        aria-hidden="true"
      ></span>
      <span
        v-if="isMenuOpened"
        class="glyphicon glyphicon-chevron-up"
        aria-hidden="true"
      >
      </span>
    </li>
    
    <collapse v-model="isMenuOpened" class="app-menu">
      <div class="app-menu-inner">
        <p class="app-message">
          <LabelFunMessage fcontId="0" msgkey="126" />
        </p>
        <p v-if="isJpTemplate || selectedTraditionalChinese" class="text-center">
          <AppCompatiblePrinters appName="lineprint" />
        </p>
        <p class="text-center modal-print-button">
          <a v-on:click="launchApp()" class="btn btn-info btn-lg" role="button">
            <LabelFunMessage fcontId="0" msgkey="30" />&nbsp;&raquo;
          </a>
        </p>
        <p>
          <LabelFunMessage fcontId="0" msgkey="128" />
        </p>
        <!-- LINE公式アカウント Epson Printer友だち追加ボタン -->
        <div class="line-freand-add">
          <a v-on:click="trackGa4AddFriendEvent()" v-if="isJpTemplate" href="https://lin.ee/iZaf3M9" target="_blank">
            <img src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" alt="友だち追加" height="50" border="0">
          </a>
          <a v-on:click="trackGa4AddFriendEvent()" v-if="selectedTraditionalChinese" href="https://lin.ee/6Vn3r3g" target="_blank">
            <img src="https://scdn.line-apps.com/n/line_add_friends/btn/zh-Hant.png" alt="加入好友" height="50" border="0">
          </a>
          <a v-on:click="trackGa4AddFriendEvent()" v-if="selectedThai" href="https://lin.ee/aBb6vVu" target="_blank">
            <img src="https://scdn.line-apps.com/n/line_add_friends/btn/th.png" alt="เพิ่มเพื่อน" height="50" border="0">
          </a>
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
import AppCompatiblePrinters from "./AppCompatiblePrinters";
import { LAUNCH_TYPE, CONTENT_TYPE, PAPER_SIZE, PAPER_TYPE } from "@/common/contentsinfo";
import { Collapse } from "uiv";

const TW_ISO639 = "zh-tw"
const JA_ISO639 = "ja"
const TH_ISO639 = "th"

// const URL_DOMAIN_DEV_TW = "https://liff.line.me/1655185814-5y7DkrdK"
// const URL_DOMAIN_DEV_JA = "https://liff.line.me/1654452557-XRza9RBW"
// const URL_DOMAIN_DEV_TH = "https://liff.line.me/1655185824-2jQjOR0y"
const URL_DOMAIN_TW = "https://liff.line.me/1655326005-z1Elkmpg"
const URL_DOMAIN_JA = "https://liff.line.me/1655213304-4ZQEyE9K"
const URL_DOMAIN_TH = "https://liff.line.me/1655325997-WG7zgBrJ"

export default {
  name: "PrintMenuLinePrint",
  components: {
    LabelFunMessage,
    AppCompatiblePrinters,
    Collapse
  },
  props: {
    launchType: String, // select, print
    contentType: String, // designPaper, photoLayout, nenga など
    categoryId: String, // designPaperの場合：xxx
    designId: String, // designPaperの場合：xx-xx
    mediaSizeId: String, // LINEプリントでは未使用
    mediaTypeId: String, // LINEプリントでは未使用
    fcontId: String,
  },
  data() {
    return {
      isMenuOpened: false,
      app_root: process.env.VUE_APP_ROOT
    };
  },
  computed: {
    ...mapGetters(["isJpTemplate", "isWwTemplate"]),
    ...mapState(["os", "lg2"]),
    isMobile: function () {
      return this.os == "ios" || this.os == "ard";
    },
    urlDomain: function () {
      switch(this.lg2) {
        case 'zh':
          return URL_DOMAIN_TW;
        case 'ja':
          return URL_DOMAIN_JA;
        case 'th':
          return URL_DOMAIN_TH;
        default:
          return URL_DOMAIN_JA;
      }
    },
    selectedTraditionalChinese: function () {
      return this.lg2 == "zh";
    },
    selectedThai: function () {
      return this.lg2 == "th";
    },
    isDesignPaperSupport: function () {
      if (this.isJpTemplate || (this.isWwTemplate && this.selectedTraditionalChinese) || (this.isWwTemplate && this.selectedThai)) {
        if ((this.mediaSizeId == PAPER_SIZE.A4 && this.mediaTypeId == PAPER_TYPE.plain)
        || (this.mediaTypeId == PAPER_SIZE.Letter && this.mediaTypeId == PAPER_TYPE.plain)) {
          return true
        }else {
          return false
        }
      } else {
        return false;
      }
    },
    appLangage: function () {
      switch(this.lg2) {
        case 'zh':
          return TW_ISO639;
        case 'ja':
          return JA_ISO639;
        case 'th':
          return TH_ISO639;
        default:
          return JA_ISO639;
      }
    },
    isSupport: function () {
      if (this.isMobile) {
        switch (this.contentType) {
          case CONTENT_TYPE.designpaper:
          case CONTENT_TYPE.designpaperPremiumCollection:
            return this.isDesignPaperSupport;
          case CONTENT_TYPE.nenga:
          case CONTENT_TYPE.postcard:
          case CONTENT_TYPE.photoLayout:
          case CONTENT_TYPE.freeLayout:
          case CONTENT_TYPE.greetingCards:
          case CONTENT_TYPE.photobook:
          case CONTENT_TYPE.album:
          case CONTENT_TYPE.createplusContents:
          case CONTENT_TYPE.creativeTop:
          default:
            return false;
        }
      }
      return false;
    },
    selectOpenUrl: function () {
      let selectCategory = "none"
      if (this.contentType == CONTENT_TYPE.designpaperPremiumCollection) {
        selectCategory = this.categoryId
      }
      const query = [
        { key: "lang", value: this.appLangage },
        { key: "group", value: selectCategory },
        { key: "pattern", value: "none" },
      ];
      const pram = query.map((q) => `${q.key}=${q.value}`).join("&");
      return `${this.urlDomain}?${pram}`;
    },
    printOpenUrl: function () {
      let query = [
        { key: "lang", value: this.appLangage },
        { key: "group", value: this.categoryId },
        { key: "pattern", value: this.designId },
      ];
      const pram = query.map((q) => `${q.key}=${q.value}`).join("&");
      return `${this.urlDomain}?${pram}`;
    },
  },
  methods: {
    trackGa4AddFriendEvent: function() {
      this.$gtag.event("app_download", {
        "app_name": "LINE Print",
        "location_id": "printButton",
        "article_no": this.fcontId,
        "site_id": "gallery"
      })
    },
    trackGa4GoAppEvent: function() {
      this.$gtag.event("go_app", {
        "app_name": "LINE Print",
        "article_no": this.fcontId,
        "print_type": this.launchType,
        "design_id": this.designId,
        "site_id": "gallery"
      })
    },
    launchApp: function () {
      this.trackGa4GoAppEvent()

      let openUrl = "";
      switch (this.launchType) {
        case LAUNCH_TYPE.select:
          openUrl = this.selectOpenUrl;
          break;
        case LAUNCH_TYPE.print:
          openUrl = this.printOpenUrl;
          break;
        default:
          openUrl = this.selectOpenUrl;
      }
      window.open(openUrl, '_blank')
      this.$log.debug("url", openUrl);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-group-item {
  font-size: 18px;
  /* LINEロゴの方で規程されているマージンを.line-logoで設定するため */
  padding: 2px 15px 2px 7px;
}

.menu-logo {
  /** 
  アイコンの最小サイズは40px(スマホ)20px(PC)
  アイコンの周辺余白をアイコンサイズx0.5を確保する必要あり
   */
  width: 40px;
  margin: 20px;
}

p.modal-print-button a {
  padding: 10px 5px;
  width: 100%;
  max-width: 300px;
}

.line-freand-add {
  text-align: center;
  margin-bottom: 10px;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
}
</style>